module.exports = __webpack_public_path__ + "static/media/home-page-preview.c0a2759b.webp";